import { DateArg, formatDate, FormatOptions } from 'date-fns'

function normalizeBackendDate(rawDate: string): string {
  // Example input: "2024-12-13 13:07:06.488 +0000 UTC"
  return rawDate
    .trim()
    .replace(' ', 'T') // Replace space between date and time with 'T'
    .replace(' +0000 UTC', 'Z') // Replace timezone with 'Z' for UTC
}

function dateFormatSafe(date: Date | string): Date {
  if (date instanceof Date) return date

  const normalized = normalizeBackendDate(date)

  const parsed = new Date(normalized)

  if (isNaN(parsed.getTime())) {
    throw new Error(`Invalid date format: "${date}"`)
  }

  return parsed
}

function dateFormat(
  date: DateArg<Date> & {},
  formatStr: string = 'dd/MM/yyyy',
  options?: FormatOptions
) {
  if (!date) return undefined!
  const parsed = dateFormatSafe(date as string)
  return formatDate(parsed, formatStr, options)
}

export { dateFormat }
